import { render, staticRenderFns } from "./LookupValueDemo.vue?vue&type=template&id=53f73758"
import script from "./LookupValueDemo.vue?vue&type=script&lang=js"
export * from "./LookupValueDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports